var _circle, _circle2, _g, _g2, _rect, _rect2, _rect3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect4, _rect5, _path9, _rect6, _rect7, _path10, _rect8, _rect9, _path11, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgItemchecklist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 108,
    viewBox: "0 0 108 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 54,
    r: 54,
    fill: "#ECEDEE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1417_1222",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 108,
    height: 108
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 54,
    r: 54,
    fill: "#ECEDEE"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1417_1222)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1417_1222)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.8,
    y: 27,
    width: 86.4,
    height: 85.5,
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1417_1222)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.8,
    y: 7.20001,
    width: 86.4,
    height: 19.8,
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.8,
    y: 27,
    width: 86.4,
    height: 29.7,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 19,
    width: 16.5,
    height: 3,
    fill: "#ECEDEE"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 16,
    width: 36,
    height: 9,
    fill: "#DADCE0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33 69H17V85H33V69ZM31.4001 70.6H18.6001V83.4H31.4001V70.6Z",
    fill: "#DADCE0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.319 78.8275C55.319 79.7375 54.5815 80.475 53.6715 80.475H42.6881C41.7782 80.475 41.0406 79.7375 41.0406 78.8275V67.295C42.6881 67.295 41.7782 67.295 42.6881 67.295H53.6715C54.5815 67.295 53.6715 67.295 55.319 67.295V78.8275Z",
    fill: "#006A53"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.295 73.3358C38.8442 73.3358 38.5411 73.3358 38.8442 73.3358H40.4917C40.7949 73.3358 40.1485 73.3358 41.0409 73.3358V80.475H55.3192V73.3358C55.8684 73.3358 55.5652 73.3358 55.8684 73.3358H57.5159C57.819 73.3358 57.6532 73.3358 58.065 73.3358V81.5733C58.065 82.7864 57.0815 83.77 55.8684 83.77H40.4917C39.2786 83.77 38.295 82.7864 38.295 81.5733V73.3358Z",
    fill: "#008B6D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5344 82.9462H56.0057L57.2413 87.065H54.77L53.5344 82.9462Z",
    fill: "#DADCE0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8257 82.9462H40.3544L39.1188 87.065H41.5901L42.8257 82.9462Z",
    fill: "#DADCE0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M55.319 78.8275C55.319 79.7375 54.5815 80.475 53.6715 80.475H42.6881C41.7782 80.475 41.0406 79.7375 41.0406 78.8275V67.295C42.6881 67.295 41.7782 67.295 42.6881 67.295H53.6715C54.5815 67.295 53.6715 67.295 55.319 67.295V78.8275Z",
    fill: "#DADCE0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M55.319 80.475H41.0406V76.6308C42.139 76.6308 41.5327 76.6308 42.139 76.6308H54.2206C54.8269 76.6308 54.2206 76.6308 55.319 76.6308V80.475Z",
    fill: "#ECEDEE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M38.295 73.3358C38.8442 73.3358 38.5411 73.3358 38.8442 73.3358H40.4917C40.7949 73.3358 40.1485 73.3358 41.0409 73.3358V80.475H55.3192V73.3358C55.8684 73.3358 55.5652 73.3358 55.8684 73.3358H57.5159C57.819 73.3358 57.6532 73.3358 58.065 73.3358V81.5733C58.065 82.7864 57.0815 83.77 55.8684 83.77H40.4917C39.2786 83.77 38.295 82.7864 38.295 81.5733V73.3358Z",
    fill: "#DADCE0"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 67,
    y: 70.2273,
    width: 24,
    height: 4.74545,
    fill: "#ECEDEE"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 67,
    y: 79.7181,
    width: 8,
    height: 4.74545,
    fill: "#ECEDEE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M48.63 50.9463C53.6344 50.9463 57.6912 46.8894 57.6912 41.885H39.5687C39.5687 46.8894 43.6256 50.9463 48.63 50.9463Z",
    fill: "#ECEDEE"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 39.5687,
    y: 39.4138,
    width: 18.1225,
    height: 2.47125,
    fill: "#DADCE0"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 37,
    width: 16,
    height: 16,
    fill: "#008B6D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0909 42.0909L23.8001 46.3818L21.9092 44.4909C21.628 44.2097 21.1721 44.2097 20.8909 44.4909C20.6098 44.7721 20.6098 45.2279 20.8909 45.5091L23.2909 47.9091C23.5721 48.1903 24.028 48.1903 24.3092 47.9091L29.1092 43.1091C29.3903 42.8279 29.3903 42.3721 29.1092 42.0909C28.828 41.8097 28.3721 41.8097 28.0909 42.0909Z",
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 67,
    y: 38.5909,
    width: 24,
    height: 4.74545,
    fill: "#ECEDEE"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 67,
    y: 48.0818,
    width: 13.73,
    height: 4.74545,
    fill: "#ECEDEE"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8923 84.4369L24.6097 77.1059C24.4953 76.9907 24.3404 76.9759 24.2149 77.0307C24.0941 77.0836 24 77.2025 24 77.3603V87.8503C24 88.1614 24.3607 88.3313 24.5987 88.1326L27.0043 86.113L28.5891 89.7836C28.6675 89.9656 28.8787 90.0492 29.0595 89.9703L30.302 89.4261C30.4828 89.3472 30.5658 89.1345 30.4874 88.9525L28.9147 85.3098L31.6672 85.0618C31.9753 85.034 32.1118 84.657 31.8923 84.4369Z",
    fill: "#6F777C"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1417_1222",
    x: 4.50005,
    y: 22.5,
    width: 99,
    height: 98.1,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.9,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_1417_1222"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.6
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1417_1222"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1417_1222",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1417_1222",
    x: 4.50005,
    y: 2.70001,
    width: 99,
    height: 32.4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.9,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_1417_1222"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.6
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1417_1222"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1417_1222",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItemchecklist);
export default __webpack_public_path__ + "static/media/itemchecklist.c29aa7d7f27dab9663531cf694d8283b.svg";
export { ForwardRef as ReactComponent };